import * as booking_scenarios from "./booking.scenarios.update.svelte.js";
import * as booking_update from "./booking.scenarios.update.svelte.js";
import * as booking_update_receipt from "./booking.scenarios.update.receipt.svelte.js";
import * as booking_select from "./booking.scenarios.select.svelte.js";
import * as booker_update from "./../booker/booker.scenarios.update.svelte.js";
import * as debug_actions from "./../debug/actions_debug.svelte.js";
import * as products_select from "./../products/products.scenarios.select.svelte.js";
import {booking} from "./feature.booking.svelte.js";
import {page_json, progress} from "../progress/feature.progress.svelte.js";
import InputUtil from "../../utils/InputUtil.js";
import DateTimeUtil from "../../utils/DateTimeUtil.js";
import DataUtil from "../../utils/DataUtil.js";
import * as progress_actions from "../progress/actions_progress.svelte.js";
import * as actions_progress from "../progress/actions_progress.svelte.js";
import * as actions_remote from "../remote/actions_remote.svelte.js";
import * as booking_actions from "./actions_booking.svelte.js";
import * as products_actions from "../products/actions_products.svelte.js";
import {BOOKING_TYPE_PACKAGEDEAL, BOOKING_TYPE_SAUNA, ENTRY_DURATION_2_HOUR, ENTRY_DURATION_DAY, ENTRY_DURATION_EVENING, ENTRY_TYPE_NORMAL, ENTRY_TYPE_OVERRULE_BADENKAART, ENTRY_TYPE_OVERRULE_BADENKAART_KORT} from "../../AppConstants.js";
import * as booking_scenarios_time from "./booking.scenarios.update.time.svelte.js";
import {tick} from "svelte";
import AppConfig from "../../AppConfig.js";

// se ae bk bks - subtype selectie in Step14
export function setBookingTypeInStep14(sBookingType)
{
  switch ( sBookingType )
  {
    case "se": // Dagentree
      booking.iPreselectedPackageDealID = false;
      booking_actions.setPreferredPartOfDay(ENTRY_DURATION_DAY);
      booking_actions.setPreferredEntryType(ENTRY_TYPE_NORMAL);
      booking_actions.setPreferredTypeOfBooking('sauna');
      actions_progress.apiCallRequestCalendar();
      booking_scenarios_time.adjustArrivalAndDepartureTimesIfNeededBasedOnBookingAndOtherTime();
      progress_actions.handleNextButtonClick();
      break;
    case "ae": // Avondentree
      booking.iPreselectedPackageDealID = false;
      booking_actions.setPreferredPartOfDay(ENTRY_DURATION_EVENING);
      booking_actions.setPreferredEntryType(ENTRY_TYPE_NORMAL);
      booking_actions.setPreferredTypeOfBooking('sauna');
      actions_progress.apiCallRequestCalendar();
      booking_scenarios_time.adjustArrivalAndDepartureTimesIfNeededBasedOnBookingAndOtherTime();
      progress_actions.handleNextButtonClick();
      break;
    case "bk": // Badenkaart dag
      booking_actions.setPreferredEntryType(ENTRY_TYPE_OVERRULE_BADENKAART);
      booking_actions.setPreferredPartOfDay(ENTRY_DURATION_DAY);
      booking_actions.setPreferredTypeOfBooking('sauna');
      actions_progress.apiCallRequestCalendar();
      booking_scenarios_time.adjustArrivalAndDepartureTimesIfNeededBasedOnBookingAndOtherTime();
      progress_actions.handleNextButtonClick();
      break;
    case "bks": // Badenkaart kort (2 uur)
      booking_actions.setPreferredEntryType(ENTRY_TYPE_OVERRULE_BADENKAART_KORT);
      booking_actions.setPreferredPartOfDay(ENTRY_DURATION_2_HOUR);
      booking_actions.setPreferredTypeOfBooking('sauna');
      actions_progress.apiCallRequestCalendar();
      booking_scenarios_time.adjustArrivalAndDepartureTimesIfNeededBasedOnBookingAndOtherTime();
      progress_actions.handleNextButtonClick();
      break;
  }
}

// se ae sa
export function setBookingTypeInStep10(sBookingType)
{
  switch ( sBookingType )
  {
    case "se":
      booking.iPreselectedPackageDealID = false;
      booking.sStep10CategoryChoice = 'entree';
      booking.bStep14SelectionMade = true;
      booking_actions.setPreferredPartOfDay(ENTRY_DURATION_DAY);
      booking_actions.setPreferredTypeOfBooking('sauna');

      // deze voorkeur resetten - bijvoorbeeld als iemand diens badenkaart niet in wil zetten
      booking_actions.setPreferredEntryType(ENTRY_TYPE_NORMAL);

      actions_progress.apiCallRequestCalendar();
      booking_scenarios_time.adjustArrivalAndDepartureTimesIfNeededBasedOnBookingAndOtherTime();
      break;
    case "ae": // avondentree
      booking.iPreselectedPackageDealID = false;
      booking.sStep10CategoryChoice = 'entree';
      booking.bStep14SelectionMade = true;
      booking_actions.setPreferredPartOfDay(ENTRY_DURATION_EVENING);
      booking_actions.setPreferredTypeOfBooking('sauna');

      // deze voorkeur resetten - bijvoorbeeld als iemand diens badenkaart niet in wil zetten
      booking_actions.setPreferredEntryType(ENTRY_TYPE_NORMAL);

      actions_progress.apiCallRequestCalendar();
      booking_scenarios_time.adjustArrivalAndDepartureTimesIfNeededBasedOnBookingAndOtherTime();
      break;
    case "bk": // badenkaart
      booking.sStep10CategoryChoice = 'badenkaart';
      booking.bStep14SelectionMade = true;
      booking_actions.setPreferredEntryType(ENTRY_TYPE_OVERRULE_BADENKAART);
      booking_actions.setPreferredPartOfDay(ENTRY_DURATION_DAY);
      booking_actions.setPreferredTypeOfBooking('sauna');
      actions_progress.apiCallRequestCalendar();
      booking_scenarios_time.adjustArrivalAndDepartureTimesIfNeededBasedOnBookingAndOtherTime();
      break;
    case "bks": // badenkaart short
      booking.sStep10CategoryChoice = 'badenkaart';
      booking.bStep14SelectionMade = true;
      booking_actions.setPreferredEntryType(ENTRY_TYPE_OVERRULE_BADENKAART_KORT);
      booking_actions.setPreferredPartOfDay(ENTRY_DURATION_2_HOUR);
      booking_actions.setPreferredTypeOfBooking('sauna');
      actions_progress.apiCallRequestCalendar();
      booking_scenarios_time.adjustArrivalAndDepartureTimesIfNeededBasedOnBookingAndOtherTime();
      break;
    case "sa":
      // deze voorkeur resetten - niet relevant bij arrangement
      booking.sStep10CategoryChoice = 'arrangement';
      booking.bStep14SelectionMade = true;
      booking_actions.setPreferredEntryType(ENTRY_TYPE_NORMAL);

      booking_actions.setPreferredTypeOfBooking('packagedeal');

      actions_progress.apiCallRequestCalendar();
      booking_scenarios_time.adjustArrivalAndDepartureTimesIfNeededBasedOnBookingAndOtherTime();
      booking.bWasBookingTypeAtStartPackageDeal = true;
      break;
    case "entree":
      // Categorie selectie vanaf homepage - gebruiker kiest subtype in Step14
      booking.sStep10CategoryChoice = 'entree';
      booking.bStep14SelectionMade = false;
      booking_actions.setPreferredTypeOfBooking('sauna');
      actions_progress.apiCallRequestCalendar();
      break;
    case "badenkaart":
      // Categorie selectie vanaf homepage - gebruiker kiest subtype in Step14
      booking.sStep10CategoryChoice = 'badenkaart';
      booking.bStep14SelectionMade = false;
      booking_actions.setPreferredTypeOfBooking('sauna');
      actions_progress.apiCallRequestCalendar();
      break;
  }
}

export function setNrOfPeople(iNrOfPeople)
{
  // alert("DEBUG set nr of people " + iNrOfPeople);
  debug_actions.debugAddLogFlow('booking', 'setNrOfPeople', {iNrOfPeople: iNrOfPeople});
  if ( iNrOfPeople < 1 ) return;
  booking_scenarios.scenarioSetNrOfPeople(iNrOfPeople);
}

export function addPerson()
{
  debug_actions.debugAddLogFlow('booking', 'addPerson');
  booking_scenarios.scenarioAddPerson();
}

export function setArrivalDate(iDay, iMonth, iYear, bIsPreset = false)
{
  debug_actions.debugAddLogFlow('booking', 'setArrivalDate', {iDay, iMonth, iYear});
  booking_scenarios.scenarioSetArrivalDate(iDay, iMonth, iYear);

  // We halen hier meteen het eventueel gekozen arrangement weg (tenzij die preset is.. dan hoeft dat niet omdat de kalenderdata
  // dan ook alleen maar dagen aan heeft geboden waarop dat arrangement beschikbaar is).
  // Ter info: als later de ajax call met alle behandeldata voor vandaag terugkomt kieperen we ook alle niet beschikbare behandelingen
  // uit de bon en voor alle producten de eventueel al gekozen voorkeurstijden.

  if ( bIsPreset !== true )
  {
    booking_update.removeNonPreselectedPackageDeals();
  }

  // Als dit een niet-arrangementsboeking is dan moeten we de entreeprijs updaten met de prijs uit de kalenderdata
  let sSelectedDate = iYear + '-' + iMonth + '-' + iDay;

  let iProductEntryID = booking_select.getCurrentlySelectedNonActionEntry();
  // console.log('setArrivalDate iProductEntryID:', iProductEntryID);
  if ( iProductEntryID )
  {
    if ( typeof progress.aCalendarDates[sSelectedDate] !== "undefined" && typeof progress.aCalendarDates[sSelectedDate]['p_' + iProductEntryID] !== "undefined" )
    {
      // dit werkt hier omdat setArrivalDate meestal aan wordt geroepen vanuit de kalender en die tonen we pas na het ophalen van actuele prijzen
      console.log('setArrivalDate update entree ', iProductEntryID, ' met een dagprijs van ', progress?.aCalendarDates[sSelectedDate]['p_' + iProductEntryID], sSelectedDate, $state.snapshot(progress.aCalendarDates));
      products_actions.updateProductPriceForDay({
        iPrice: progress?.aCalendarDates[sSelectedDate]['p_' + iProductEntryID],
        iBuyableID: iProductEntryID,
        sStartDate: booking.sArrivalDate
      });
    }
    else
    {
      console.log('setArrivalDate iProductEntryID', iProductEntryID, ' met selected date ', sSelectedDate, ' komt niet voor in ', $state.snapshot(progress.aCalendarDates));
    }
  }
  else
  {
    console.log('setArrivalDate iProductEntryID onbekend', iProductEntryID);
  }
}

export function setArrivalDateByString(sDate)
{
  return;
  debug_actions.debugAddLogFlow('booking', 'setArrivalDateByString', {sDate});
  //window.console.log('booking', 'setArrivalDateByString', {sDate});
  booking_scenarios.scenarioSetArrivalDateByString(sDate);
}

export function setArrivalTime(iTime)
{
  debug_actions.debugAddLogFlow('booking', 'setArrivalTime', {iTime});

  if ( iTime === false )
  {
    booking_scenarios.scenarioClearArrivalTime();
  }
  else
  {
    iTime = parseInt(iTime);
    booking_scenarios.scenarioSetArrivalTime(iTime);

    // start kijken of we een afgedwongen 2 uurs boeking hebben
    if ( booking.sPreferredPartOfTheDay === ENTRY_DURATION_2_HOUR && booking.sSelectedEntryType === ENTRY_TYPE_OVERRULE_BADENKAART_KORT )
    {
      booking_scenarios.scenarioSetDepartureTime(iTime + 200);
      // console.log('zet met het oog op de 2 uurs entree de eindtijd op ', iTime + 200);
    }
    // einde kijken of we een afgedwongen 2 uurs boeking hebben
  }
}

export function setDepartureTime(iTime)
{
  let bClearDiner = false;
  debug_actions.debugAddLogFlow('booking', 'setDepartureTime', {iTime});

  if ( iTime === false )
  {
    bClearDiner = true;
    booking_scenarios.scenarioClearDepartureTime();
  }
  else
  {
    booking_scenarios.scenarioSetDepartureTime(iTime);

    if ( iTime <= AppConfig.iNoDinnerUntilAfterThisTime )
    {
      bClearDiner = true;
    }
  }

  if ( bClearDiner === true )
  {
    booking_update.resetDinnerPreference();
  }
}

export function addOrReplacePackageDeal(iPackageDealID)
{
  iPackageDealID = parseInt(iPackageDealID);
  debug_actions.debugAddLogFlow('booking', 'addOrReplacePackageDeal', {iPackageDealID});
  booking_scenarios.scenarioAddOrReplacePackageDeal(iPackageDealID);
  //BookingApp.bCloseAllPackageDealCatsNow = true;
}

export function removePackageDeal(iPackageDealID)
{
  iPackageDealID = parseInt(iPackageDealID);
  debug_actions.debugAddLogFlow('booking', 'removePackageDeal', {iPackageDealID});
  booking_scenarios.scenarioRemovePackageDeal(iPackageDealID);

  // trigger een kalender update voor entreeprijzen
  actions_progress.apiCallRequestCalendar();
}

export function setPreferredPartOfDay(sPreferredPartOfTheDay)
{
  debug_actions.debugAddLogFlow('booking', 'setPreferedPartOfDay', {sPreferredPartOfTheDay: sPreferredPartOfTheDay});
  booking_scenarios.scenarioSetPreferredPartOfDay(sPreferredPartOfTheDay);
}

export function setPreferredEntryType(sPreferredEntryType)
{
  debug_actions.debugAddLogFlow('booking', 'setPreferredEntryType', {sPreferredEntryType: sPreferredEntryType});
  booking_scenarios.scenarioSetPreferredEntryType(sPreferredEntryType);
}

export function addPackageDealProductToPerson(iPersonID, iPackageDealID, iBuyableID, iChoiceID)
{
  debug_actions.debugAddLogFlow('booking', 'addPackageDealProductToPerson', {iPersonID, iPackageDealID, iBuyableID, iChoiceID});
  booking_scenarios.scenarioAddPackageDealProductToPerson(iPersonID, iPackageDealID, iBuyableID, iChoiceID);
}

export function addProduct(iID, sOptionalPersonID = false)
{
  debug_actions.debugAddLogFlow('booking', 'addProduct', {iID, sOptionalPersonID});

  const iProductID = parseInt(iID);
  booking_scenarios.scenarioAddProduct(iProductID, sOptionalPersonID);
  //BookingApp.bCloseAllTreatmentCatsNow = true;
}

export function removeProduct(iBuyableID, sOptionalPersonID = false, bIsManualRemoval = false)
{
  debug_actions.debugAddLogFlow('booking', 'removeProduct', {iBuyableID, sOptionalPersonID});

  if ( iBuyableID === booking.iPreselectedTreatmentID && bIsManualRemoval === true )
  {
    // als iemand er echt met het handje expliciet voor kiest om een preset product uit de bon te verwijderen
    // dan heeft diegene de interesse in die ene massage opgegeven en is nu met een normale boeking bezig
    // dat betekent ook dat bij het kiezen van een nieuwe datum de preset behandeling niet meer opnieuw toegevoegd zal worden
    booking.iPreselectedTreatmentID = false;
  }

  booking_scenarios.scenarioRemoveProduct(iBuyableID, sOptionalPersonID);
}

export function changeTimeSlot(sPersonID, iBuyableID, sTimeSlot, sTimeSlotLabel)
{
  debug_actions.debugAddLogFlow('booking', 'changeTimeSlot', {sPersonID, iBuyableID, sTimeSlot, sTimeSlotLabel});
  booking_scenarios.changeTimeSlot(sPersonID, iBuyableID, sTimeSlot, sTimeSlotLabel);
}

export function setPreferredTypeOfBooking(sBookingType)
{
  console.log('setPreferredTypeOfBooking', sBookingType);

  debug_actions.debugAddLogFlow('booking', 'setPreferredTypeOfBooking', {sBookingType});

  progress.bIsBookingTypeChosen = true;

  if ( sBookingType === 'packagedeal' )
  {
    booking.sBookingType = BOOKING_TYPE_PACKAGEDEAL;
    booking_scenarios.scenarioSetShowPackageDeals(true);
    //booking_scenarios.scenarioSetWantsSauna(false);
  }
  else if ( sBookingType === 'sauna' )
  {
    booking.sBookingType = BOOKING_TYPE_SAUNA;
    booking_update.removePackageDealsForEveryone();
    booking_scenarios.scenarioSetShowPackageDeals(false);
    //booking_scenarios.scenarioSetWantsSauna(true);
  }
  else if ( sBookingType === 'nosauna' )
  {
    booking.sBookingType = false; // voor nu dit
    booking_scenarios.scenarioSetShowPackageDeals(false);
    //booking_scenarios.scenarioSetWantsSauna(false);
  }
}

// export function setWantsSauna(bWantsSauna)
// {
//   debug_actions.debugAddLogFlow('booking', 'setWantsSauna', {bWantsSauna});
//   booking_scenarios.scenarioSetWantsSauna(bWantsSauna);
// }

export function setWantsDinner(bWantsDinner)
{
  debug_actions.debugAddLogFlow('booking', 'setWantsDinner', {bWantsDinner});
  booking_scenarios.scenarioSetWantsDinner(bWantsDinner);
}

export function setPreferredDinnerTime(sPreferredTime)
{
  debug_actions.debugAddLogFlow('booking', 'setPreferredDinnerTime', {sPreferredTime});
  booking_scenarios.scenarioSetPreferredDinnerTime(sPreferredTime);
}

export function setShowPackageDeals(bShowListOfPackageDeals)
{
  debug_actions.debugAddLogFlow('booking', 'setShowPackageDeals', {bShowListOfPackageDeals});
  booking_scenarios.scenarioSetShowPackageDeals(bShowListOfPackageDeals);

  if ( bShowListOfPackageDeals )
  {
    //booking_scenarios.scenarioSetWantsSauna(true);
  }
  else
  { // stel bWantsSauna opnieuw in op de huidige waarde zodat eventueel entrees worden toegevoegd als dat nodig is.
    //booking_scenarios.scenarioSetWantsSauna(bCurrentWantsSauna);
  }
}

export function setGiftCard(sGiftCardCode)
{
  debug_actions.debugAddLogFlow('booking', 'setGiftCard', {sGiftCardCode});

  // Set fetching state
  progress.bIsFetchingGiftCardValue = true;
  booking.sGiftCardError = false;

  // Call remote API to validate giftcard

  actions_remote.validateGiftcard(sGiftCardCode)
    .then(response => {
      // console.log('debug response 1', response);
      progress.bIsFetchingGiftCardValue = false;

      if ( response && response.iValueCents && response.iValueCents > 0 )
      {
        // console.log('debug response 2', response);
        setGiftCardSuccess({
          iGiftcardValueCents: response.iValueCents,
          sGiftcardCode: sGiftCardCode
        });
      }
      else
      {
        setGiftCardFailure(response?.errorMessage || 'Deze cadeaubon code is niet geldig.');
      }
    })
    .catch(error => {
      progress.bIsFetchingGiftCardValue = false;
      setGiftCardFailure('Er is een fout opgetreden bij het valideren van de cadeaubon.');
    });
}

export function handleBookingUpdated(sDebugMessage)
{
  //window.console.log('handleBookingUpdated', sDebugMessage);

  // doe alle dingen die moeten reageren op veranderingen in de booking
  // NB - deze volgorde niet aanpassen als je niet zeker weet wat je doet
  tick().then(() => {
    booking_select.updateBookingSummary(); // VOOR calculateBookingTotals omdat die de berekeningen baseert op de meest recente summary
    booking_update_receipt.calculateBookingTotals();
    booker_update.reevaluateAllowedPaymentMethods();
    booking.iBookingUpdateCounterForUIElements += 1;

    //console.log('trigger updateNextButtonState handleBookingUpdated');
    progress_actions.updateNextButtonState();
  });
}

export function setGiftCardSuccess(oGiftCardResponseData)
{
  // console.log('setGiftCardSuccess', oGiftCardResponseData);
  debug_actions.debugAddLogFlow('booking', 'setGiftCardSuccess', {oGiftCardResponseData});

  const iTotal = booking.mTotals.mTotal.iCents;

  // in de oude situatie mocht niet een hogere giftcardwaarde hebben dan de boeking
  // if ( oGiftCardResponseData?.iGiftcardValueCents > 0 && oGiftCardResponseData.iGiftcardValueCents <= iTotal )
  // {
  //   booking_scenarios.scenarioAddGiftcard(oGiftCardResponseData.iGiftcardValueCents, oGiftCardResponseData.sGiftcardCode);
  //   booking_update_receipt.calculateBookingTotals();
  // }
  // else
  // {
  //   booking.sGiftCardError = 'De waarde van de cadeaubon is hoger dan de waarde van uw reservering. Dit is helaas niet mogelijk.';
  // }

  // nieuwe situatue: je mag opmaken wat je wil
  booking_scenarios.scenarioAddGiftcard(oGiftCardResponseData.iGiftcardValueCents, oGiftCardResponseData.sGiftcardCode);
  booking_update_receipt.calculateBookingTotals();
  booker_update.reevaluateAllowedPaymentMethods();
}

export function setGiftCardFailure(sErrorCode = 'Deze code is niet correct of al gebruikt.')
{
  debug_actions.debugAddLogFlow('booking', 'setGiftCardFailure', {sErrorCode});
  booking.sGiftCardError = sErrorCode;
  progress.bIsFetchingGiftCardValue = false;
}

export function setBadenkaart(sBadenkaartCode)
{
  debug_actions.debugAddLogFlow('booking', 'setBadenkaart', {sBadenkaartCode});
  // booking_scenarios.evaluateBadenkaartCodeValidity(sBadenkaartCode);
  // booking_scenarios.setFetchingBadenkaartValue(true);
}

export function setBadenkaartSuccess(oBadenkaartResponseData)
{
  debug_actions.debugAddLogFlow('booking', 'setBadenkaartSuccess', {oBadenkaartResponseData});

  const iBookingTotal = booking.mTotals.mTotal.iCents;
  const iCurrentlySelectedNonActionEntryID = booking_select.getCurrentlySelectedNonActionEntry();

  if ( iCurrentlySelectedNonActionEntryID )
  {
    const oCurrentlySelectedNonActionEntry = products_select.getProductByID(iCurrentlySelectedNonActionEntryID);
    const iCurrentlySelectedNonActionEntryPrice = oCurrentlySelectedNonActionEntry?.iPrice;
    if ( iCurrentlySelectedNonActionEntryPrice && iCurrentlySelectedNonActionEntryPrice <= iBookingTotal )
    {
      booking_scenarios.scenarioAddBadenkaart(iCurrentlySelectedNonActionEntryPrice, oBadenkaartResponseData.sBadenkaartCode);
      booking_update_receipt.calculateBookingTotals();
    }
    else
    {
      booking.sBadenkaartError = iBookingTotal <= 0 ? 'Het totaal bedrag van de boeking is al €0,-' : 'De waarde van de badenkaart is hoger dan de waarde van uw reservering. Dit is helaas niet mogelijk.';
    }
  }

  booker_update.reevaluateAllowedPaymentMethods();

  progress.bIsFetchingBadenkaartValue = false;
}

export function setBadenkaartFailure(sErrorCode = 'Deze code is niet correct of al gebruikt.')
{
  // debug_actions.debugAddLogFlow('booking', 'setBadenkaartFailure', {sErrorCode});
  // booking_scenarios.setBadenkaartError(sErrorCode);
  // booking_scenarios.setFetchingBadenkaartValue(false);
}

export function importFromPageConfigAjaxCall()
{
  const aInputSettingsFromRequest = InputUtil._getInputFromGetAndPost();
  // hier geen defaults aan state geven.. dat moet hiervoor in reducer_booking gebeuren

  let sInputArrivalDate = false;

  if ( typeof aInputSettingsFromRequest['d'] !== 'undefined' )
  {
    //sInputArrivalDate = aInputSettingsFromRequest['d'];
  }

  // // if (typeof aInputSettingsFromRequest['s'] !== 'undefined') booking.set('iArrivalTime', DateTimeUtil.getTimeWithoutColon(aInputSettingsFromRequest['s']) );
  //if ( typeof aInputSettingsFromRequest['p'] !== 'undefined' ) booking.iInitialNrOfPeople = parseInt(aInputSettingsFromRequest['p']);

  // html source
  if ( typeof page_json.data.jsonHmkImgURLMain !== 'undefined' ) progress.sImageURLMain = page_json.data.jsonHmkImgURLMain;
  if ( typeof page_json.data.jsonHmkImgURLProduct !== 'undefined' ) progress.sImageURLProduct = page_json.data.jsonHmkImgURLProduct;
  if ( typeof page_json.data.jsonHmkImgURLMainPackage !== 'undefined' ) progress.sImageURLPackageDeal = page_json.data.jsonHmkImgURLMainPackage;

  if ( typeof page_json.data.jsonHmkResSessionPresetUpsellPoductIDs !== 'undefined' ) booking.aPresetUpsellProductIDs = page_json.data.jsonHmkResSessionPresetUpsellPoductIDs;

  if ( typeof page_json.data.jsonHmkResSessionDate !== 'undefined' && page_json.data.jsonHmkResSessionDate !== 'false' && page_json.data.jsonHmkResSessionDate !== false )
  {
    sInputArrivalDate = DateTimeUtil.convertYYYYdashMMdashDDToDDdashMMdashYYYY(page_json.data.jsonHmkResSessionDate);

    if ( DateTimeUtil.isDateInPast(sInputArrivalDate) !== true )
    {
      //window.console.log("set sArrivalDate op basis van page_json 2", sInputArrivalDate)
      //booking.sArrivalDate = sInputArrivalDate;
    }
  }

  if ( sInputArrivalDate )
  {
    // Zorg dat we dit format krijgen: "23-3-2025"
    // charAt begint bij 0
    if ( sInputArrivalDate.charAt(4) === '-' )
    {
      // Dan is het format nu "2025-03-23"
      sInputArrivalDate = DateTimeUtil.convertYYYYdashMMdashDDToDDdashMMdashYYYY(sInputArrivalDate, true);
    }

    if ( sInputArrivalDate.charAt(2) === '-' && sInputArrivalDate.split('-').length === 3 )
    {
      // datum is (nu) in het goede format
      let aInputArrivalDate = sInputArrivalDate.split('-');
      let sInputArrivalDay = parseInt(aInputArrivalDate[0]);
      let sInputArrivalMonth = parseInt(aInputArrivalDate[1]);
      let sInputArrivalYear = parseInt(aInputArrivalDate[2]);

      if ( sInputArrivalDate !== false && DateTimeUtil.isDateInPast(sInputArrivalDate) !== true )
      {
        booking.sPreselectedDate = sInputArrivalDate;
        booking.sPreselectedDateDay = sInputArrivalDay;
        booking.sPreselectedDateMonth = sInputArrivalMonth;
        booking.sPreselectedDateYear = sInputArrivalYear;
      }
    }
  }

  if ( typeof page_json.data.jsonHmkServiceMessage !== 'undefined' )
  {
    progress.bShowServiceMessage = true;
    progress.bShowNoticeInRightPanel = true; // voor nu is dit de plek
    progress.sServiceMessageColor = page_json.data.jsonHmkServiceMessage.Color;
    progress.sServiceMessageContent = page_json.data.jsonHmkServiceMessage.Content;
  }


  if ( typeof page_json.data.jsonHmkResSessionNrOfPeople !== 'undefined' && page_json.data.jsonHmkResSessionNrOfPeople !== 'false' && page_json.data.jsonHmkResSessionNrOfPeople !== false ) booking.iInitialNrOfPeople = parseInt(page_json.data.jsonHmkResSessionNrOfPeople);
  if ( typeof page_json.data.jsonHmkResSessionValidRedeemCodes !== 'undefined' && page_json.data.jsonHmkResSessionValidRedeemCodes !== false && page_json.data.jsonHmkResSessionValidRedeemCodes !== 'false' ) booking.aValidRedeemCodes = page_json.data.jsonHmkResSessionValidRedeemCodes;
  if ( typeof page_json.data.jsonHmkResSessionIsAction !== 'undefined' && page_json.data.jsonHmkResSessionIsAction !== 'false' && page_json.data.jsonHmkResSessionIsAction !== false ) booking.bIsAction = DataUtil.convertToBoolean(page_json.data.jsonHmkResSessionIsAction);
  //if ( typeof page_json.data.jsonHmkDisabledDays !== 'undefined' && page_json.data.jsonHmkDisabledDays !== 'false' && page_json.data.jsonHmkDisabledDays !== false ) booking.aDaysThatCannotBeBooked = JSON.parse(page_json.data.jsonHmkDisabledDays);

  if ( typeof page_json.data.jsonHmkDaysActionIsAvailableFor !== 'undefined' && page_json.data.jsonHmkDaysActionIsAvailableFor !== 'false' && page_json.data.jsonHmkDaysActionIsAvailableFor !== false )
  {
    if ( JSON.parse(page_json.data.jsonHmkDaysActionIsAvailableFor) !== null )
    {
      booking.aDaysActionIsAvailableFor = JSON.parse(page_json.data.jsonHmkDaysActionIsAvailableFor);
    }
  }

  // AANTAL PERSONEN
  if ( typeof page_json.data.jsonHmkResSessionFixedNrOfPeople !== 'undefined' && page_json.data.jsonHmkResSessionFixedNrOfPeople !== false && page_json.data.jsonHmkResSessionFixedNrOfPeople !== 'false' )
  { // fixed wint van alles
    booking.iFixedNrOfPeople = parseInt(page_json.data.jsonHmkResSessionFixedNrOfPeople);
    booking.iInitialNrOfPeople = parseInt(page_json.data.jsonHmkResSessionFixedNrOfPeople);
  }
  else
  {
    // niet fixed.. wat hebben we nog meer?

    if ( typeof page_json.data.jsonHmkMinimumAmountOfPeople !== 'undefined' && page_json.data.jsonHmkMinimumAmountOfPeople !== null && page_json.data.jsonHmkMinimumAmountOfPeople !== 'null' && page_json.data.jsonHmkMinimumAmountOfPeople !== 'false' && page_json.data.jsonHmkMinimumAmountOfPeople !== false )
    {
      // NB je hebt initial, minimum en fixed - progress_update.performBootSequence
      // sowieso het minumum overnemen
      if ( parseInt(page_json.data.jsonHmkMinimumAmountOfPeople) !== 0 )
      {
        booking.iMinimumAmountOfPeople = parseInt(page_json.data.jsonHmkMinimumAmountOfPeople);
      }

      // als het minimum groter is dan initial dan rekken we initial ook even op
      if ( booking.iInitialNrOfPeople > 0 && parseInt(page_json.data.jsonHmkMinimumAmountOfPeople) > booking.iInitialNrOfPeople )
      {
        booking.iInitialNrOfPeople = parseInt(page_json.data.jsonHmkMinimumAmountOfPeople);
      }
    }
  }

  // ACTIE
  let bIsAction = false;
  if ( typeof page_json.data.jsonHmkResSessionActionID !== 'undefined' && page_json.data.jsonHmkResSessionActionID !== '-1' && page_json.data.jsonHmkResSessionActionID !== -1 )
  {
    booking.iPreselectedActionEntryProductID = parseInt(page_json.data.jsonHmkResSessionActionID);
    booking.bIsAction = true;
  }

  if ( typeof page_json.data.jsonHmkResSessionExtraEntree !== 'undefined' ) booking.aExtraBoekbareEntreesNaastActie = DataUtil.isJsonString(page_json.data.jsonHmkResSessionExtraEntree);

  // preselections
  if ( typeof page_json.data.jsonHmkResSessionType !== 'undefined' )
  {
    if ( page_json.data.jsonHmkResSessionType === 'bk' )
    {
      if ( AppConfig.bIsBadenkaartDagEnabled === true )
      {
        booking.sPreselectedBookingType = page_json.data.jsonHmkResSessionType;
      }
    }
    else if ( page_json.data.jsonHmkResSessionType === 'bks' )
    {
      if ( AppConfig.bIsBadenkaartShortEnabled === true )
      {
        booking.sPreselectedBookingType = page_json.data.jsonHmkResSessionType;
      }
    }
    else
    {
      // alle dingen zonder eigen schakelaartje mogen sowieso
      booking.sPreselectedBookingType = page_json.data.jsonHmkResSessionType;
    }

  }

  if ( typeof page_json.data.jsonHmkResSessionType !== 'undefined' && typeof page_json.data.jsonHmkResSessionID !== 'undefined' )
  {
    switch ( page_json.data.jsonHmkResSessionType )
    {
      case 'se':
        if ( page_json.data.jsonHmkResSessionID !== false )
        {
          booking.iUseThisEntryIDForFirstPerson = parseInt(page_json.data.jsonHmkResSessionID);
        }
        break;
      case 'sa':
        if ( page_json.data.jsonHmkResSessionID !== false )
        {
          booking.iPreselectedPackageDealID = parseInt(page_json.data.jsonHmkResSessionID);
        }
        booking.bWasBookingTypeAtStartPackageDeal = true;
        booking.bShowListOfPackageDeals = true;
        break;
    }
  }

  if ( typeof page_json.data.jsonHmkResSessionTreatmentID !== 'undefined' )
  {
    booking.iPreselectedTreatmentID = parseInt(page_json.data.jsonHmkResSessionTreatmentID);
  }

  if ( typeof page_json.data.jsonHmkResSessionTreatmentCatID !== 'undefined' && page_json.data.jsonHmkResSessionTreatmentCatID !== '' && page_json.data.jsonHmkResSessionTreatmentCatID !== false && page_json.data.jsonHmkResSessionTreatmentCatID !== 'false' ) booking.iPreselectedTreatmentSubcat = parseInt(page_json.data.jsonHmkResSessionTreatmentCatID);
  if ( typeof page_json.data.jsonHmkResSessionTreatmentCatTitle !== 'undefined' && page_json.data.jsonHmkResSessionTreatmentCatTitle !== '' && page_json.data.jsonHmkResSessionTreatmentCatTitle !== false && page_json.data.jsonHmkResSessionTreatmentCatTitle !== 'false' ) booking.sPreselectedTreatmentSubcatTitle = page_json.data.jsonHmkResSessionTreatmentCatTitle;

  // extra info bij preselecties
  if ( typeof page_json.data.jsonHmkResPreselectionTitle !== 'undefined' && page_json.data.jsonHmkResPreselectionTitle !== '' && page_json.data.jsonHmkResPreselectionTitle !== false && page_json.data.jsonHmkResPreselectionTitle !== 'false' ) booking.iPreselectionTitle = page_json.data.jsonHmkResPreselectionTitle;
  if ( typeof page_json.data.jsonHmkResPreselectionImgURL !== 'undefined' && page_json.data.jsonHmkResPreselectionImgURL !== '' && page_json.data.jsonHmkResPreselectionImgURL !== false && page_json.data.jsonHmkResPreselectionImgURL !== 'false' ) booking.iPreselectionImgUrl = page_json.data.jsonHmkResPreselectionImgURL;
  if ( typeof page_json.data.jsonHmkResPreselectionContent !== 'undefined' && page_json.data.jsonHmkResPreselectionContent !== '' && page_json.data.jsonHmkResPreselectionContent !== false && page_json.data.jsonHmkResPreselectionContent !== 'false' ) booking.iPreselectionContent = page_json.data.jsonHmkResPreselectionContent;

}
